import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-dieta-chetogenica',
  templateUrl: './dieta-chetogenica.component.html',
  styleUrls: ['./dieta-chetogenica.component.scss']
})
export class DietaChetogenicaComponent implements OnInit {

  pageTitle = "Dieta Chetogenica | Leone Lifestyle";
  desc = "Alimentarsi oggi"
  shareImg = "masthead-dieta-chetogenica.jpg";

  constructor(private seo: SEOService) {}
  
  ngOnInit(): void {

    //EMBEED CALCULATOR
    var site = 'https://calculator-online.net/';
    var Calculator = '/tdee-calculator/'
    var widget = site + Calculator + 'preview/';
    var widgetHtml = '<iframe id="ifr" src="' + widget + '" style="border:0;width:100%;height:500px;"></iframe>'+
    '<p style="width:100%;text-align:center;">TDEE Calculator by <a style="color:#13699E;text-decoration:none;" href="https://calculator-online.net/tdee-calculator/" target="_blank" title="Calculator-online.net">calculator-online.net</a></p>';
    var isNew = document.getElementById("tdee_widget_code");
    document.getElementById("tdee_widget_code").innerHTML = widgetHtml;

    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

  scrollTo($what){
    $(document).ready(function (){
      $('html, body').animate({
         scrollTop: $($what).offset().top -110
        }, 1000);
    })
  }
}
